/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_completed = () => `Abgeschlossen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_endingText = () => `Abgeschlossen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_startingText = () => `In Arbeit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_registered = () => `Registriert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_viewed = () => `Gesehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_bestPractices = () => `Best practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_collection = () => `Zertifikat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_course = () => `Kurse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_lesson = () => `Lektion`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_metaDesc = () => `Du erfährst, wie du dein Geschäft mit Klaviyo ausbauen kannst. Beginne mit unseren Kursen, Zertifizierungen und Leitfäden, die dir helfen, Klaviyo erfolgreich zu nutzen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_opengraphSiteName = () => `Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_search = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_title = () => `Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_href = () => `/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_label = () => `Zur Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_titleText = () => `Nicht gefunden | Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_href = () => `/de-de/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_label = () => `Alle Ressourcen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_headline = () => `Mach dich fit mit der Klaviyo Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_subhead = () => `Lerne die Strategien und Best Practices kennen, um den Umsatz zu maximieren und deine Geschäftsziele zu erreichen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_headline = () => `Entscheide, wie du lernen möchtest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_href = () => `/de-de/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_label = () => `Alle Leitfäden für die ersten Schritte anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_content = () => `<p>Befolge die Schritt-für-Schritt-Anleitungen, um mit neue Kanäle, Funktionen und Produkte auszuprobieren.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_title = () => `Erste Schritte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_href = () => `/de-de/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_label = () => `Alle Best Practices anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_content = () => `<p>Baue dein Geschäft aus und optimiere dein Marketing mit unseren Top-Strategien.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_title = () => `Best Practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_href = () => `/de-de/search?select=Quick+guide|Under+10+minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_label = () => `Alle Kurzanleitungen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_content = () => `<p>Finde Antworten in 10—Minuten oder weniger mit praktischen, kurzen Anleitungen.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_title = () => `Kurzanleitungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_href = () => `/de-de/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_label = () => `Alle Live-Schulungen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_content = () => `<p>Nimm an Live-Sitzungen mit Klaviyo Expert*innen teil und erhalte Antworten auf deine Fragen in Echtzeit.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_title = () => `Live-Schulungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_href = () => `/de-de/search?select=Course`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_label = () => `Alle Kurse anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_content = () => `<p>Erfahre, wie du Marketing-Strategien mit On-Demand-Lerninhalten und praktischen Beispielen in deinem Unternehmen effektiv anwenden kannst.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_title = () => `Kurse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_href = () => `/de-de/search?select=Certificate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_label = () => `Alle Zertifikate anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_content = () => `<p>Tauche mit einer Reihe von Kursen tiefer in ein Thema ein. Teste dein Wissen mit einer Abschlussprüfung, um ein Abschlusszertifikat zu erhalten.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_title = () => `Zertifikat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_subhead = () => `Wähle aus einer Vielzahl von Optionen, die zu deinem Zeitplan und Lernstil passen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_href = () => `/de-de/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_label = () => `Alle Live-Schulungen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_subhead = () => `Lerne von unserem Expertenteam in Echtzeit.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_title = () => `Registriere dich für eine Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_description = () => `Aufschlüsselung E-Mail Zustellbarkeit mit Strategien zur Bewertung und Verbesserung deiner Performance.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_href = () => `https://www.bigmarker.com/klaviyo-customer-education/strategy-session-understand-email-deliverability`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_pill = () => `Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_title = () => `Grundlegendes zur E-Mail-Zustellbarkeit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_description = () => `Lerne Designprinzipien kennen, um Traffic und Conversion zu steigern.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-Design-emails-that-convert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_pill = () => `Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_title = () => `Entwerfe E-Mails, die konvertieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_description = () => `Verstehe wie wertvoll SMS als Kanal sind und wie du sie in deinen Workflow integrieren kannst.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-SMS-marketing-strategy-North-America`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_pill = () => `Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_title = () => `SMS-Marketing-Strategie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_description = () => `Stelle deine strategischen Fragen an die Expert*innen von Klaviyo in Echtzeit.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Office-hours-Getting-started-with-Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_pill = () => `Live-Schulung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_title = () => `Sprechstunde`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_href = () => `/de-de/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_label = () => `Best Practices anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_excerpt = () => `Lerne die besten Marketing-Strategien kennen, um Kunden zu gewinnen, Kundenbindung zu automatisieren und den Umsatz zu steigern.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_title = () => `Best-Practice-Leitfäden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_href = () => `https://www.youtube.com/channel/UCLLurTBYufj95_5zTnJISnA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_label = () => `Besuche die YouTube-Bibliothek`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_excerpt = () => `Schau dir Video-Tutorials an, um relevante Tipps und Experteneinblicke zu erhalten, um dein Geschäft mit Klaviyo auszubauen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_title = () => `Klaviyo auf YouTube`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_href = () => `/de-de/courses/anatomy-of-a-flow-welcome-series/1881997`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_label = () => `Jetzt lernen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_excerpt = () => `Erstelle einen personalisierten Welcome Flow und lerne Best Practices kennen, um die Bindungen mit Abonnenten zu stärken.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_title = () => `Anatomie eines Flows: Welcome Flow`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_headline = () => `Neu und bemerkenswert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_subhead = () => `Informiere dich über die neuesten Kurse, Leitfäden und Schulungen von unserem globalen Expertenteam.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_href = () => `/de-de/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_label = () => `Alle Ressourcen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_collectionPath = () => `/de-de/collections/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_coursePath = () => `/de-de/courses/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_title = () => `Empfohlene Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_href = () => `/de-de/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_label = () => `Alle Leitfäden für die ersten Schritte anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_description = () => `Erfahre, wie du dein E-Commerce-Ökosystem integrierst, Abonnenten vermehrst und mit Klaviyo Nachrichten versenden kannst.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_href = () => `/de-de/courses/getting-started-with-klaviyo/1459179`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_pill = () => `Kurse, Erste Schritte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_title = () => `Erste Schritte mit Anmeldeformularen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_description = () => `Erfahre, was Segmente sind, wie du sie erstellst und wie du Segmente verwendest, um gezieltere Marketingkampagnen zu senden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_href = () => `/de-de/courses/getting-started-with-sms/1411601`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_pill = () => `Kurse, Erste Schritte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_title = () => `Erste Schritte mit Segmenten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_description = () => `Klaviyo Kampagnen – bist du nicht weitergekommen? Werde zum Profi mit Insider-Tipps von 143.000 Marken in unserem Kurs zu Kampagnen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_href = () => `/de-de/courses/getting-started-with-klaviyo-cdp/1759043`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_pill = () => `Erste Schritte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_title = () => `Erste Schritte mit Kampagnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_description = () => `Lerne die Grundlagen des Flows kennen, erstelle deinen ersten automatisierten Flow in Klaviyo und befolge Best Practices, um deinen Umsatz zu steigern.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_divider = () => `false`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_href = () => `/de-de/courses/develop-a-klaviyo-reviews-strategy/1630005`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_pill = () => `Erste Schritte, Kurs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_title = () => `Erste Schritte mit Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_title = () => `Beginne mit den Grundlagen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_headline = () => `Das sagen unsere Kunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_href = () => `/de-de/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_label = () => `Melde dich für eine Schulung an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_size = () => `groß`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_text = () => `Die Beispiele. Es ist immer hilfreich zu sehen, wie die Expert*innen das machen. Dank dieser Schulungen habe ich gelernt, mich in Klaviyo zurechtzufinden und damit effektiver zu arbeiten <3`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_href = () => `/de-de/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_label = () => `Melde dich für eine Schulung an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_size = () => `klein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_text = () => `Die Beispiele aus der Praxis, die Schritt-für-Schritt-Anleitung und die Best Practices waren ERSTAUNLICH. Die Webinare von Klaviyo lohnen sich für mich am meisten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_href = () => `/de-de/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_label = () => `Melde dich für eine Schulung an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_size = () => `klein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_text = () => `Optimistisch, direkt und prägnant. Klar und direkt. Meine Zeit ist wertvoll, und das wurde respektiert. Tolle Demo!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_href = () => `/de-de/search?select=live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_label = () => `Melde dich für eine Schulung an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_size = () => `groß`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_text = () => `Ich fand die einzelnen Sprecher wirklich interessant. Alle waren kompetent und konnten die Inhalte auf spannende Weise vermitteln. Ich fand die Erkenntnisse sehr hilfreich und schätzte sorgfältige Planung dieser Schulungen sehr.  Danke Klaviyo! Am Ende der Schulung schwirrte mein Kopf vor Ideen für meine Kunden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alertBar_dismiss = () => `Nachricht ignorieren/ausblenden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_singleLineForm_error = () => `Gib eine gültige E-Mail Adresse ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_singleLineForm_placeholderText = () => `E-Mail-Adresse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_singleLineForm_primaryButton = () => `Jetzt starten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_skipButton_skipContent = () => `Zum Hauptinhalt springen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_currentSlide = () => `Aktuelle Folie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_goToSlide = () => `Gehe zu Folie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_blog = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_home = () => `Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_searchAll = () => `Alle durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_sitemap = () => `Sitemap`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_general = () => `Hinweis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_requirements = () => `Anforderungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_warning = () => `Warnung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_name = () => `Ausgewählte Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_slug = () => `/hc/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_account = () => `Anfrage zum Kontozugriff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_article = () => `Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_category = () => `Kategorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_metaDesc = () => `Durchsuche unsere Wissensdatenbank, um Antworten auf häufige Fragen zu finden. In unseren Artikeln, im Community-Forum, in live stattfindenden oder aufgezeichneten Trainings und mehr erfährst du alles über die Nutzung von Klaviyo und lernst unsere Best Practices kennen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_opengraphSiteName = () => `Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_search = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_section = () => `Abschnitt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_title = () => `Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_moreCardHeadline = () => `Mehr von Klaviyo entdecken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_searchHeadline = () => `Was möchtest du heute wissen?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_href = () => `/hc/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_label = () => `Zum Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_titleText = () => `Nicht gefunden | Klaviyo Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_siteName = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_category_topArticles = () => `Top-Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_headline = () => `Ausgewählte Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_subhead = () => `Entdecke Leitfäden, Kurse und Materialien, um dein Unternehmen mit Klaviyo auszubauen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL20R80_headline = () => `Nach Thema suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL30R70_headline = () => `Nach Thema suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsInstantSearch = () => `Keine Ergebnisse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperSuggestion = () => `Probiere es mit einer anderen Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperText = () => `Keine Ergebnisse für`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_academy_headline = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_community_headline = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_developers_headline = () => `Entwickler*innen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_helpCenter_headline = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_marketing_headline = () => `Marketing-Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_viewAll = () => `Alle anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCode_languageString = () => `German`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_locale = () => `de-DE`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_localeLowerCase = () => `de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_pathPrefix = () => `de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_recaptchaLanguage = () => `de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_timezone = () => `Europe/Berlin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecule_unifiedSearchResultGridItem_nextEventDetails_upcomingDates = () => `Zukünftige Termine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_estimated = () => `Geschätzt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_minuteRead = () => `Lesedauer in Minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_updated = () => `Aktualisiert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_contactSupport = () => `So kontaktierst du den Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_checkBoxLabel = () => `Klaviyo darf mich zu meinem Feedback kontaktieren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_describe = () => `Beschreibe, was du tun, erfahren oder lösen möchtest.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_errorLabel = () => `Achte darauf, dass deine E-Mail-Adresse nur ein @ enthält, gefolgt von einer gültigen Domain (name@beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticle = () => `Wie können wir diesen Artikel verbessern?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticleSuggestion = () => `Beschreibe, was dir gefallen hat oder wie der Artikel verbessert werden könnte.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_incompleteLabel = () => `Weitere Details oder Erklärungen nötig`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_irrelevantLabel = () => `Hat nichts damit zu tun, wonach ich gesucht habe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_legend = () => `Danke, dass du uns informiert hast! Bitte erzähle uns mehr über das Problem.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_moreDetail = () => `Könntest du das noch genauer ausführen?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_submit = () => `Senden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_description = () => `Wir werden dich nur in Bezug auf dein Feedback zu diesem Artikel kontaktieren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_label = () => `E-Mail-Adresse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_placeholder = () => `name@beispiel.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_unclearLabel = () => `Unklar, verwirrend oder schwer zu verstehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_wrongLabel = () => `Entspricht nicht der Erfahrung mit dem Produkt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_furtherAssistance = () => `Nutze dieses Formular nur für Feedback zu Artikeln.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_headline = () => `War dieser Artikel hilfreich?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_no = () => `Nein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_success = () => `Wir haben dein Feedback erhalten. Danke!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_thanks = () => `Wir freuen uns, dass der Inhalt hilfreich war!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_yes = () => `Ja`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_authorAltText = () => `Profilfoto des Autors/der Autorin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_defaultAuthorAltText = () => `Klaviyo-Bild`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_minRead = () => `Lesedauer in Minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogCard_read = () => `Lesen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_days = () => `Tage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_hours = () => `Std.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_minutes = () => `Min.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_seconds = () => `Sek.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_filterBlock_topic = () => `Thema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseDepartment_openRoles = () => `offene Rollen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_save = () => `Speichern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_saved = () => `Gespeichert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_next = () => `Weiter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_previous = () => `Zurück`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_relatedCard_openInANewTab = () => `wird in einer neuen Registerkarte geöffnet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_searchBox_placeholder = () => `Nach Thema oder Stichwort suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articleSingular = () => `Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articlesPlural = () => `Artikel`


/**
 * @param {{ days: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_d = (params) => `${params.days}Tagen.`


/**
 * @param {{ hours: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_h = (params) => `${params.hours}Stunden.`


/**
 * @param {{ minutes: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_m = (params) => `${params.minutes}M`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_now = () => `Jetzt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_day = () => `Tag`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_days = () => `Tagen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hour = () => `Stunde`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hours = () => `Stunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minute = () => `Minute`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minutes = () => `Minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartIn = () => `Dieses Event beginnt in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartsNow = () => `Dieses Event beginnt jetzt.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_href = () => `/auth/logout`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_label = () => `Von Academy abmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label = () => `Meine Qualifikationen auf Accredible anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_href = () => `https://v2.accounts.accredible.com/retrieve-credentials`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_label = () => `Meine Qualifikationen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_label = () => `Meine Academy-Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_href = () => `/auth/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_label = () => `Bei Academy anmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_href = () => `https://www.klaviyo.com/de/contact-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_label = () => `Kontaktiere uns`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_href = () => `https://www.klaviyo.com/dashboard`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_label = () => `Konto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_label = () => `Anmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_href = () => `https://www.klaviyo.com/support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_label = () => `Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_href = () => `https://www.klaviyo.com/de/search-all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_label = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_anchorLinks_backToTop = () => `Zurück zum Anfang`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_overview = () => `Übersicht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_tableContents = () => `Inhalt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_eyebrow = () => `BFCM 2024`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headline = () => `Jeder Tag zählt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iAm = () => `Ich bin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iWantTo = () => `Ich möchte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_thisBfcm = () => `an Black Friday und Cyber Monday (BFCM)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogArticleHero_featureImageAltText = () => `Ausgewähltes Bild`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewAll = () => `Alle Beiträge anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewCategory = () => `Kategorie anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_tagline = () => `Deine Ressource für dein Marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_title = () => `Der Klaviyo-Ansatz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogSearchHero_customSearchHeadline = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogSearchHero_placeholder = () => `Blogbeiträge durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_days = () => `Tage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_hours = () => `Stunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_minutes = () => `Minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_seconds = () => `Sekunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType = () => `Art der E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_announcement = () => `Ankündigung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_productLaunch = () => `Produkteinführung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_productPromotion = () => `Produktwerbung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_productUpdate = () => `Produkt-Update`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_campaignType_storewideSale = () => `Sale im ganzen Store`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_examplePrompt = () => `Beispiel-Prompt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry = () => `Branche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty = () => `Kosmetik`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt = () => `Unser brandneuer matter Lippenstift in mehr als 10 Farbtönen – exklusiv online erhältlich. Jetzt entdecken!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1 = () => `Unsere neue Kollektion matter Lippenstifte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10 = () => `Entdecke mehr als 10 brillante Farbtöne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11 = () => `Entdecke unsere lebendigen matten Farbtöne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12 = () => `💄 Entdecke jetzt die neueste Kollektion`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2 = () => `💋 Dein neuer Look mit unseren neuen Lippenstiften`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3 = () => `Entdecke deinen perfekten matten Farbton`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4 = () => `Zeige dein schönstes Lächeln! 💋`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5 = () => `Entdecke unseren exklusiven matten Lippenstift`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6 = () => `Dein neuer Look mit unseren neuen Farbtönen ✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7 = () => `Dein perfekter Farbton`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8 = () => `Dein perfekter Schmollmund 💄`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9 = () => `Achtung, nur online: unser neuer matter Lippenstift 🚨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt = () => `Zeitlich begrenztes Angebot: 20 % auf alle Sonnencremes. Jetzt sichern!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1 = () => `Schütze deinen Glanz ☀️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10 = () => `☀️ Jetzt bei Sonnenschutzprodukten sparen! 🌞`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11 = () => `Die Sonne scheint. Jetzt bei Sonnencreme sparen!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12 = () => `Die Preise schmelzen! 🌞`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2 = () => `Exklusives Angebot: 20 % auf Sonnencreme 😎`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3 = () => `Deine perfekte Bräune – jetzt mit 20 % Rabatt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4 = () => `🌞 Schütze deine Haut jetzt noch günstiger`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5 = () => `Deine Haut schützen und jetzt sparen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6 = () => `Hoher LSF zum Schnäppchenpreis ☀️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7 = () => `20 % auf Sonnenschutz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8 = () => `Spare 20 % bei Sonnencreme`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9 = () => `☀️ Schütze dich in der Sonne! Spare 20 % bei Sonnencreme 🌞`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg = () => `Verbrauchsgüter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt = () => `Neue Fairtrade- und Bio-zertifizierte mittelstarke Röstung mit Geschmacksnoten von gebackener Birne, Melasse und Mandel. Perfekt als Espresso und Filterkaffee!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1 = () => `Entdecke unseren neuen Fairtrade-Kaffee 🌿`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10 = () => `Ein neues Geschmackserlebnis mit dem Aroma von gebackener Birne 🌿`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11 = () => `Genieße unsere neue mittelstarke Fairtrade-Röstung ☕🌿`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12 = () => `Ein neues Geschmackserlebnis mit dem Aroma von gebackener Birne und Mandel 🍐☕`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2 = () => `Eine neue köstliche Kaffeemischung ☕️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3 = () => `Genuss mit jedem Schluck 😋`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4 = () => `Mit dem Aroma von gebackener Birne 🍐`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5 = () => `Sichere dir noch heute ein neues Geschmackserlebnis 🌱`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6 = () => `☕ Entdecke unseren köstlichen neuen Kaffee`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7 = () => `Entdecke unsere neueste mittelstarke Bio-Röstung ☕`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8 = () => `Jetzt neu: unser Fairtrade-Kaffee mit einzigartigen Noten 🍐`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9 = () => `Entdecke unsere neueste Fairtrade-Mischung 🌍`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt = () => `Nur für begrenzte Zeit: 1 kaufen, 1 gratis für alle Geschmacksrichtungen. Jetzt schnell zuschlagen!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1 = () => `Doppelte Menge zum halben Preis!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10 = () => `Jetzt sparen und genießen! 🍭`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11 = () => `Doppelt genießen! 🍦`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12 = () => `Doppelter Geschmack zum halben Preis!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2 = () => `Gönne dir die doppelte Menge`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3 = () => `Jetzt ganz entspannt 1 kaufen und 1 gratis erhalten ☀️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4 = () => `Ein Deal zum Genießen: 1 kaufen, 1 gratis erhalten 🍨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5 = () => `Zeitlich begrenztes Angebot: 1 kaufen, 1 gratis für alle Geschmacksrichtungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6 = () => `Letzte Chance, sich einzudecken 🍦`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7 = () => `1 kaufen, 1 GRATIS für ALLE Geschmacksrichtungen!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8 = () => `Jetzt sichern: 1 kaufen, 1 gratis für alle Geschmacksrichtungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9 = () => `Nicht verpassen: 1 kaufen, 1 gratis erhalten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion = () => `Mode`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt = () => `Jetzt neu: unser Oversize-Minikleid. Kombiniere es mit Sneakern für deinen coolen Freizeit-Look`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1 = () => `Dein neuer Freizeit-Look`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10 = () => `Der Star in deinem Kleiderschrank 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11 = () => `Jetzt neu: Oversize-Minikleid`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12 = () => `Neues Oversize-Minikleid für deinen Freizeit-Look`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2 = () => `Dein neuer Style: Oversize-Minikleid`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3 = () => `Der neue coole Style 💃🏻`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4 = () => `Frischer Oversize-Look`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5 = () => `Freue dich auf unser neues Oversize-Minikleid!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6 = () => `Das neue angesagte Minikleid`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7 = () => `Das neue Must-have-Minikleid 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8 = () => `Der neue Star in deinem Kleiderschrank 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9 = () => `Freue dich auf deinen neuen Freizeit-Look!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt = () => `Weicher und eleganter Rundhals-Sweater für jeden Anlass – jetzt im Sale!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1 = () => `Sale: bequemer Rundhals-Sweater 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10 = () => `Dieser stylische Sweater ist dein neuer Look`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11 = () => `Unschlagbares Angebot für unseren Rundhals-Sweater`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12 = () => `Vielseitige Eleganz zum kleinen Preis 💫`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2 = () => `Dieser Sweater ist dein neuer Style`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3 = () => `Das superweiche Essential 🧶`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4 = () => `Jetzt im Sale: vielseitiger Baumwoll-Sweater ✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5 = () => `Der neue coole Style: unser vielseitiger Sweater ✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6 = () => `Bequem und schick zum unschlagbaren Preis 🛍️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7 = () => `🌟 Zeitlich begrenztes Angebot für schicke Strickwaren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8 = () => `Stylischer Rundhals-Sweater im Sale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9 = () => `Rundhals-Sweater jetzt im Sale!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden = () => `Haus und Garten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt = () => `Unser neuer Werkzeugsatz 2.0: Mit diesem 40-teiligen Upgrade des Vorgängermodells erledigst du alle Arbeiten souverän.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1 = () => `Gönne deinem Werkzeugkasten jetzt ein Upgrade 🔧🔨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10 = () => `Unser Werkzeugsatz 2.0 – das Upgrade für deinen Werkzeugkasten 🛠️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11 = () => `Jetzt entdecken: Werkzeugsatz 2.0 💡`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12 = () => `Werkzeugsatz 2.0 – das Upgrade für deine Werkzeugsammlung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2 = () => `Erledige deine Arbeiten schneller mit dem Werkzeugsatz 2.0 🔧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3 = () => `Mit dem Werkzeugsatz 2.0 wirst du zum Heimwerkerprofi!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4 = () => `Werkzeugsatz 2.0 – jetzt sichern! 🛠️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5 = () => `Das ultimative Upgrade für deinen Werkzeugkasten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6 = () => `Zeit für ein Upgrade deiner Werkzeugsammlung 🛠️✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7 = () => `Erledige mit dem ultimativen Werkzeug-Upgrade souverän alle Arbeiten 🛠️✨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8 = () => `Erledige mühelos jedes Heimwerkerprojekt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9 = () => `Mit unseren neuen und verbesserten Werkzeugen erledigst du alle Arbeiten mühelos ⚙️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt = () => `Nur für begrenzte Zeit: 20 % Rabatt auf der gesamten Website – auch auf unsere meistverkauften Edelstahl-Töpfe und -Pfannen. Sichere dir jetzt professionelles Kochzubehör für deine Küche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1 = () => `20 % auf ein Upgrade für deine Küche! 🍳`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10 = () => `Koche zu Hause wie die Profis 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11 = () => `Spare jetzt bei professionellem Kochzubehör 🍳`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12 = () => `Koche wie die Profis – jetzt mit 20 % Rabatt!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2 = () => `Kochen wie die Profis – jetzt mit 20 % Rabatt! 🥘`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3 = () => `20 % auf professionelles Kochzubehör`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4 = () => `Koche wie die Profis – jetzt mit 20 % Rabatt! 🔥`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5 = () => `Spare jetzt bei einem Upgrade für deine Küche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6 = () => `Kochen wie die Profis – zum kleinen Preis! 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7 = () => `Sichere dir dieses Angebot für professionelles Kochzubehör`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8 = () => `Exklusives Angebot: Spare 20 % bei allen Küchenutensilien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9 = () => `Top-Deals für deine Küche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness = () => `Restaurant und Wellness`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt = () => `Gehobenes italienisches Restaurant mit neuen Herbstgerichten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1 = () => `Entdecke unsere Herbstgerichte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10 = () => `Genieße unsere neuen herbstlichen Gerichte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11 = () => `Entdecke unsere kreativen Herbstgerichte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12 = () => `Genieße die Aromen des Herbstes 🍁`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2 = () => `Genieße den Herbst mit unseren neuen Gerichten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3 = () => `🍁 Genieße italienische Köstlichkeiten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4 = () => `Entdecke unsere neue Herbstkarte 🍝`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5 = () => `Erlebe unsere herbstlich inspirierten Gerichte 🍂`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6 = () => `Genieße unsere saisonalen Gerichte 🍝`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7 = () => `🍁 Herbstliche Genüsse in unserem Restaurant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8 = () => `Bei uns schmeckst du den Herbst! 🍝`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9 = () => `Entdecke unsere exklusive Herbstkarte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt = () => `Zeitlich begrenztes Sonderangebot: Spare die Anmeldegebühr in deinem Fitnessstudio vor Ort! Jetzt registrieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1 = () => `Fit ohne Gebühren!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10 = () => `Jetzt Angebot sichern: kostenlose Anmeldung 🎉`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11 = () => `Exklusives Angebot: kostenlose Anmeldung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12 = () => `Lasse dir die kostenlose Anmeldung nicht entgehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2 = () => `Jetzt anmelden und sparen 🌟`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3 = () => `Tue deinem Körper noch heute etwas Gutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4 = () => `Spare dir die Gebühr und melde dich jetzt an 💪`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5 = () => `Die kostenlose Anmeldung endet bald!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6 = () => `Fit werden und sparen 💪`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7 = () => `Nicht verpassen: kostenlose Anmeldung! 🏋️‍♂️`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8 = () => `Zeit, fit zu werden! Jetzt ohne Anmeldegebühr 💪`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9 = () => `Schnell anmelden und Gebühr sparen!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_loading = () => `Betreffzeilen werden generiert.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_emailSubjectLineGenerator_submit = () => `Generieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_excerpt = () => `Integriere deinen Shop und sende deine ersten Nachrichten mit Klaviyo.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_href = () => `https://academy.klaviyo.com/en-us/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_postTitle = () => `Erste Schritte mit Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_resource = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_excerpt = () => `Schaffe die Grundlagen für erfolgreiches SMS-Marketing.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_href = () => `/hc/de-de/articles/4404274419355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_postTitle = () => `So richtest du SMS in Klaviyo ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_excerpt = () => `Erstelle und sende deine erste E-Mail-Kampagne.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_href = () => `/hc/de-de/articles/115005054847`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_postTitle = () => `So erstellst und sendest du eine E-Mail-Kampagne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_excerpt = () => `Verwende Formulare, um mit deinen Abonnent*innen zu interagieren und mehr Informationen über sie zu sammeln.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_href = () => `/hc/de-de/articles/360026474752`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_postTitle = () => `Erste Schritte mit Anmeldeformularen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_excerpt = () => `Erstelle vollständige Flows in beliebiger Größenordnung durch Eingaben in natürlicher Sprache.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_href = () => `/hc/de-de/articles/26604555031963`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_postTitle = () => `So nutzt du Flows AI zum Erstellen eines Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_excerpt = () => `Sammle Kundenfeedback und sorge für mehr Conversions.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_href = () => `/hc/de-de/articles/15937542819355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_postTitle = () => `Erste Schritte mit Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_resource = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuresList_loadMore = () => `Mehr laden`


/**
 * @param {{ year: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_copyright = (params) => `Copyright © ${params.year} Klaviyo. Alle Rechte vorbehalten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_privacySettings = () => `Deine Datenschutzeinstellungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_articleMetaTitle = () => `Anfrage zum Kontozugriff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_href = () => `/hc/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_label = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_currentBreadcrumb = () => `Anfrage zum Kontozugriff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_email = () => `Achte darauf, dass deine E-Mail-Adresse nur ein @ enthält, gefolgt von einer gültigen Domain (name@beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_issueRecipeients = () => `Bitte gib eine gültige E-Mail-Adresse ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_na_required = () => `Erforderlich – Antworte mit „N/A“, falls nicht zutreffend.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_required = () => `Erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_websiteUrl = () => `Achte darauf, dass die Website deines Unternehmens eine gültige Domain enthält (https://beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_label = () => `Konto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_placeholder = () => `Gib deinen Kontonamen ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_button_label = () => `+ Empfänger*in hinzufügen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_label = () => `Weitere Empfänger*innen (optional)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_placeholder = () => `Gib eine E-Mail-Adresse ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_label = () => `E-Mail-Adresse des Klaviyo-Kontos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_placeholder = () => `Gib eine E-Mail-Adresse ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_label = () => `Wobei benötigst du Hilfe?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_placeholder = () => `Beschreibe das Problem`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_2_step_authentication = () => `Multi-Faktor-Authentifizierung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_account_disabled = () => `Konto deaktiviert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_forgot_password = () => `Passwort vergessen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_invoice_inquiry = () => `Frage zu einer Rechnung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support = () => `Unterstützung für Multifaktor-Authentifizierung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_account_owner = () => `Aktualisierung des Kontoinhabers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_device_code = () => `Einrichten eines neuen Geräts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_setting_up_new_device = () => `Einrichten eines neuen Geräts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_label = () => `Problem`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_placeholder = () => `Wähle ein Problem aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name = () => `Name der zuletzt erstellten Kampagne oder des zuletzt erstellten Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder = () => `Kampagnen- oder Flow-Namen eingeben`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url = () => `Erstelle eine neue Seite auf der Website deines Unternehmens mit dem Titel „Klaviyo Test“ und füge die URL hier ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder = () => `Gib eine Website-URL ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info = () => `Beantworte aus Sicherheitsgründen die folgenden Fragen so gut wie möglich, um deine Identität zu bestätigen. Wenn du dir nicht sicher bist, gib „N/A“ ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_info = () => `Verwende dieses Formular nur bei Problemen mit der Multi-Faktor-Authentifizierung (MFA), z. B. wenn du keinen Zugriff auf dein Authentifizierungsgerät hast. Dieses Formular erfordert die Angabe persönlicher Informationen für eine manuelle Authentifizierung. Wähle bei anderen Problemen als mit der MFA eine andere Option aus.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date = () => `Geschätztes Datum der letzten Anmeldung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder = () => `Datum eingeben`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address = () => `Gespeicherte Anschrift des Unternehmens`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder = () => `Adresse eingeben`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails = () => `Namen oder E-Mail-Adressen von anderen Benutzer*innen in deinem Konto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder = () => `Namen oder E-Mail-Adressen eingeben`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names = () => `Namen oder E-Mail-Adressen von fünf Profilen in deinem Konto, die mindestens einen Monat alt sind`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder = () => `Gib Namen oder E-Mail-Adressen ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason = () => `Grund auswählen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_lost_access_authenticator_app = () => `Kein Zugriff auf die Authentifizierungs-App mehr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_device = () => `Neues Gerät`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_phone_number = () => `Neue Telefonnummer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_sms_code = () => `SMS-Code nicht erhalten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice = () => `Wie war der Betrag deiner letzten Klaviyo-Rechnung?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder = () => `Rechnungsbetrag eingeben`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_label = () => `Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_placeholder = () => `Gib deinen vollständigen Namen ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_submit_button_label = () => `Senden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_label = () => `Website-URL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_placeholder = () => `Gib eine Website-URL ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_headline = () => `Hast du Probleme beim Zugriff auf dein Konto?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_subhead = () => `Sende deine Informationen an unser Support-Team. Ein Teammitglied wird sich in Kürze bei dir melden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_href = () => `/hc/de-de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_label = () => `Zur Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_headline = () => `Deine Anfrage wurde übermittelt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_subhead = () => `Unser Support-Team wird sich so bald wie möglich bei dir melden. Eine Antwort wird an die von dir angegebene(n) E-Mail-Adresse(n) gesendet.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_allRequired = () => `Alle Felder müssen ausgefüllt werden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_body = () => `Nutze die kostenlose Demo und entdecke die Leistungsfähigkeit der Klaviyo-Datenplattform, KI-gestützte Erkenntnisse, personalisierte SMS und E-Mails sowie viele weitere Funktionen. `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_button = () => `Demo anfordern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_buttonSubmitting = () => `Wird gesendet …`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headline = () => `Erzähle uns von deiner Marke`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headlineEmbedded = () => `Erzähle uns von deiner Marke`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_recaptcha_privacy = () => `Diese Website wird durch reCAPTCHA geschützt. Es gelten die <a href="https://policies.google.com/privacy?hl=de">Datenschutzerklärung</a> und <a href="https://policies.google.com/terms?hl=de">Nutzungsbedingungen</a> von Google.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonOne = () => `Alle Funktionen entdecken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonTwo = () => `Marketing-Ressourcen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_headline = () => `Vielen Dank!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_generic = () => `Deine Anfrage ist nicht eingegangen. Bitte versuche es erneut.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_network = () => `Aufgrund eines Netzwerkfehlers ist deine Anfrage nicht eingegangen. Bitte versuche es erneut.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_rateLimit = () => `Du hast dich innerhalb kurzer Zeit zu oft registriert. Bitte nutze deine bestehenden Konten oder wende dich an den Kundensupport. Danke!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_recaptcha = () => `reCaptcha ist erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_agency_label = () => `Ich melde mich als Agentur für einen Kunden an.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_errors_required = () => `Bitte gib den Namen deines Unternehmens ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_label = () => `Name des Unternehmens`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_placeholder = () => `Gib hier den Namen deines Unternehmens ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_errors_required = () => `Erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_label = () => `Anzahl von Kontakten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_fiveHundred = () => `500.000 bis 1 Mio.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_one = () => `1.000 bis 2.999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneHundred = () => `100.000 bis 499.999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneMillion = () => `Über 1 Mio.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_three = () => `3.000 bis 24.999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_twentyFive = () => `25.000 bis 99.999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_zero = () => `0 bis 999`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_placeholder = () => `Wähle die Anzahl deiner Kontakte aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_required = () => `Pflichtfeld`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_url = () => `Achte darauf, dass die Website deines Unternehmens eine gültige Domain enthält (https://beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_label = () => `Webseite des Unternehmens`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_demo_requested_label = () => `Ich hätte gerne eine Live-Beratung.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_errors_required = () => `Bitte wähle ein Produkt aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_label = () => `E-Commerce-Plattform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_BigCommerce = () => `BigCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Commercetools = () => `Commercetools`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Magento = () => `Adobe Commerce (Magento)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Nuvemshop = () => `Nuvemshop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_OpenCart = () => `OpenCart`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_PrestaShop = () => `PrestaShop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Salesforce = () => `Salesforce Commerce Cloud`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopify = () => `Shopify`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_ShopifyPlus = () => `Shopify Plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopware = () => `Shopware`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_SquareOnline = () => `Square Online`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Wix = () => `Wix Stores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_WooCommerce = () => `WooCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_custom = () => `Ich habe eine individuelle Lösung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_doesNotApply = () => `Ist für mein Unternehmen nicht relevant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_other = () => `Hier nicht aufgeführte E-Commerce-Plattform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_placeholder = () => `Wähle deine Plattform aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_email = () => `Achte darauf, dass deine E-Mail-Adresse nur ein @ enthält, gefolgt von einer gültigen Domain (name@beispiel.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_required = () => `Pflichtfeld`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_label = () => `E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_placeholder = () => `name@beispiel.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_errors_required = () => `Bitte wähle deinen geschätzten Jahresumsatz aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_label = () => `Geschätzter Jahresumsatz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_five = () => `5 bis 20 Mio. $`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_fourHundred = () => `Über 400 Mio. $`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_twenty = () => `20 bis 400 Mio. $`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_underFive = () => `Weniger als 5 Mio. $`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_placeholder = () => `Wähle den geschätzten Jahresumsatz aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_errors_required = () => `Bitte wähle aus, wie du Klaviyo nutzen möchtest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_label = () => `Wie möchtest du Klaviyo nutzen?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_clientsBusiness = () => `Für das Unternehmen eines Kunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_ownBusiness = () => `Für mein eigenes Unternehmen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_placeholder = () => `Wähle aus, wie du Klaviyo nutzen möchtest`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_errors_required = () => `Bitte wähle die Art deines Unternehmens aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_label = () => `Art des Unternehmens`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_other = () => `Andere, nicht im Einzelhandel erhältliche Produkte und Dienstleistungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailGoods = () => `Einzelhandelswaren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailServices = () => `Einzelhandelsdienstleistungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_placeholder = () => `Art des Unternehmens auswählen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_firstname_errors_required = () => `Pflichtfeld`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_errors_required = () => `Pflichtfeld`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_label = () => `Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_placeholder = () => `Vollständiger Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_general_errors_required = () => `Pflichtfeld`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_lastname_errors_required = () => `Pflichtfeld`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_newsletter_label = () => `Melde dich für die Marketing-Kommunikation von Klaviyo an, um Newsletter, Blogbeiträge, Produktneuigkeiten, Webinar-Ankündigungen und zielgerichtete Werbung zu erhalten. Über den in den E-Mails enthaltenen Link „Abbestellen“ kannst du dich vom E-Mail-Marketing abmelden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_common = () => `Dein Passwort ist zu einfach.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_max = () => `Achte darauf, dass dein Passwort nicht länger als 128 Zeichen ist.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_min = () => `Achte darauf, dass dein Passwort mindestens 8 Zeichen enthält.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_required = () => `Erforderlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_label = () => `Passwort`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_placeholder = () => `Gib dein Passwort ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_matches = () => `Achte darauf, dass deine Telefonnummer deine Landesvorwahl enthält`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_max = () => `Die Nummer darf höchstens 15 Zeichen lang sein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_required = () => `Pflichtfeld`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_label = () => `Telefonnummer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_placeholder = () => `Gib deine Telefonnummer ein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_errors_required = () => `Bitte wähle ein Produkt aus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_label = () => `Welche Produkte interessieren dich? Wähle alle zutreffenden aus.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_email = () => `Email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_mobile_push = () => `Mobile Push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_reviews = () => `Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_placeholder = () => `Produkte auswählen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_website_errors_url = () => `Pflichtfeld`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_acknowledgement = () => `Mit dem Absenden dieses Formulars akzeptierst du die`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_and = () => `und`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_href = () => `/de/legal/privacy/privacy-notice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_label = () => `Datenschutzerklärung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService = () => `Nutzungsbedingungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService_href = () => `/de/legal/terms-of-service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_body = () => `Erstelle ein kostenloses Konto und automatisiere dein Marketing mit personalisierten Omnichannel-Erlebnissen, die für Conversions sorgen. `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_button = () => `Konto erstellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_buttonSubmitting = () => `Wird gesendet …`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_headline = () => `Sende deine erste Kampagne in nur wenigen Minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_glossary_jumpTo = () => `Springen zu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_allLocations = () => `Alle Standorte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_search = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_searchJobs = () => `Stellen suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_allSystemsOperational = () => `Alle Systeme betriebsbereit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_degradedSystemService = () => `Verschlechterter Systemdienst`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_majorSystemOutage = () => `Größerer Systemausfall`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorServiceOutage = () => `Kleinere Dienstunterbrechung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorSystemOutage = () => `Kleinerer Systemausfall`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partialSystemOutage = () => `Teilweiser Systemausfall`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedService = () => `Teilweise verschlechterter Dienst`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem = () => `Teilweise verschlechtertes System`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance = () => `Dienst wird gewartet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_modal_closeModal = () => `Fenster schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_href = () => `https://community.klaviyo.com/?lang=de`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_label = () => `Community besuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_eyebrow = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_icon_iconName = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_richText = () => `Vernetze dich mit Kolleg*innen, Partner*innen und Klaviyo-Expert*innen, um dich inspirieren zu lassen, Erkenntnisse auszutauschen und Antworten auf deine Fragen zu erhalten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_href = () => `https://www.klaviyo.com/events/live-training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_label = () => `Jetzt registrieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_eyebrow = () => `Live-Training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_icon_iconName = () => `Kalender`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_richText = () => `Nimm an einer Live-Session mit Klaviyo-Expert*innen teil, um mehr über Best Practices und die Einrichtung wichtiger Funktionen zu erfahren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_label = () => `Anmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_eyebrow = () => `Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_icon_iconName = () => `Support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_accessSupport = () => `Kontaktiere den Support über dein Konto.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistance = () => `Chat / virtuelle Unterstützung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability = () => `Verfügbarkeit abhängig von Standort und Abonnementtyp`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupport = () => `Support per E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAccountTypes = () => `(kostenlose Testversion und kostenpflichtige Konten)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAvailability = () => `Verfügbar 24/7`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewAllButton_text = () => `Alle Kategorien anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewLessButton_text = () => `Weniger Kategorien anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_href = () => `/demo-request`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_label = () => `Demo anfordern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_signUp_button_href = () => `/de/sign-up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_logo_label = () => `Gehe zur Klaviyo-Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_href = () => `https://www.klaviyo.com/de/customer-resources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_label = () => `Zur Ressourcenseite von Klaviyo Power-Up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_klavioLogo = () => `Klaviyo-Logo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_productNews = () => `Produktneuigkeiten von Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_read = () => `Lesen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_viewAll = () => `Alle anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceCategory = () => `Kategorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceCollection = () => `Kollektion`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceStage = () => `Phase`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_ResourceTopic = () => `Thema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_read_more = () => `Mehr lesen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_post_filter_search = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimer = () => `Inklusive Netzbetreibergebühren von geschätzt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimerEnd = () => `Der Preis pro SMS/MMS kann je nach Nachrichtenlänge variieren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credit = () => `Credit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credits = () => `Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_destination = () => `Ziel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_headline = () => `Erfahre, wie viele Textnachrichten du senden kannst.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AT = () => `Österreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AU = () => `Australien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BE = () => `Belgien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CA = () => `Kanada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CH = () => `Schweiz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DE = () => `Deutschland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DK = () => `Dänemark`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_ES = () => `Spanien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FI = () => `Finnland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FR = () => `Frankreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_GB = () => `Vereinigtes Königreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_HU = () => `Ungarn`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IE = () => `Irland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IT = () => `Italien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NL = () => `Niederlande`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NO = () => `Norwegen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NZ = () => `Neuseeland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_PL = () => `Polen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_PT = () => `Portugal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_SE = () => `Schweden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_US = () => `Vereinigte Staaten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_maxSends = () => `max. Sendungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms = () => `MMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms_limit = () => `MMS-Nachrichten können bis zu 1.600 Zeichen und Medien enthalten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms_not_available = () => `MMS ist derzeit nicht verfügbar.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_not_available = () => `Nicht verfügbar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePer = () => `Preis pro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePerSend = () => `Preis pro Sendung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sendTo = () => `Senden an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_service_type = () => `Typ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms_limit = () => `SMS-Nachrichten sind auf 160 Zeichen begrenzt.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactLimitExceeded = () => `Limit für aktives Profil überschritten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactSales = () => `Vertrieb kontaktieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts = () => `aktive Profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts_slider_headline = () => `Wie viele aktive Profile hast du?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts_slider_subText = () => `Aktive Profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts_slider_subTextInfo = () => `Hier handelt es sich um Personen, denen du E-Mails senden kannst, wie z. B. Abonnent*innen oder Personen, die mit deinen Nachrichten interagieren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_credits_slider_headline = () => `Wie viele SMS-/MMS-Credits pro Monat benötigst du?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_credits_slider_subText = () => `SMS/MMS-Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_credits_slider_subTextInfo = () => `Deine Credits nutzt du zum Senden von Textnachrichten. Für SMS und MMS fällt eine unterschiedliche Anzahl an Credits an. Die Kosten für den jeweiligen Nachrichtentyp findest du unten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_csm = () => `Customer Success Manager – 1.500 $/Monat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_emailAndChatSupport = () => `Support via E-Mail und Chat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_eyebrow = () => `Berechne die voraussichtlichen Kosten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeCredits = () => `kostenlose monatliche SMS/MMS-Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeSupport = () => `E-Mail-Support für die ersten 60 Tage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_getADemo = () => `Demo anfordern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_headline = () => `Wie viele aktive Profile hast du?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_includesFees = () => `Einschließlich etwaiger Netzbetreibergebühren für SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_buttons_getDemo = () => `Demo anfordern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_headline = () => `Lass uns reden!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_richTextBody = () => `Wenn du mehr als 250.000 aktive Profile hast, wende dich bitte an unser Vertriebsteam, um das für dich passende Abonnement zu finden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_mobilePush = () => `Mobile-Push-Nachrichten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText1 = () => `Du kannst deine Credits für SMS, MMS oder beides nutzen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText2 = () => `Wie viele Credits für SMS- und MMS-Nachrichten anfallen, unterscheidet sich je nach Empfängerstandort.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_headline = () => `SMS/MMS-Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_month = () => `Monat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlyEmailSends = () => `monatlich gesendete E-Mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlySmsMmsCredits = () => `monatliche SMS/MMS-Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_onboarding = () => `Onboarding – 450 $/Monat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_opensAModal = () => `(Pop-up-Fenster wird geöffnet)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_per_month = () => `pro Monat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_advance_data_platform_subTextTooltiptInfo = () => `Dies beinhaltet alle Personen in deinem Konto, unabhängig vom Kanal (E-Mail, SMS, Push) oder Marketing-Status.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_advanced_data_platform_headline = () => `Advanced Klaviyo Data Platform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_advanced_data_platform_pricingDescription = () => `Der Preis richtet sich nach der Gesamtzahl der Profile.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_collapsible_button = () => `Weniger anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_copy = () => `Optimiere dein Marketing. Marken, die Email und SMS kombinieren, verzeichnen einen Anstieg von 19 % beim Bruttowarenwert.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_name = () => `Email und SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_creditsSubText = () => `SMS-/MMS-Credits pro Monat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_name = () => `Email + SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailPlusSms_recommended = () => `🔥 Empfohlen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_copy = () => `Gehe den nächsten Schritt in deinem E-Mail-Marketing – mit einer einfachen Lösung für umfassende Personalisierung.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_emails_label = () => `E-Mails`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_name = () => `Email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_per_month = () => `E-Mails pro Monat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_expandable_button = () => `Mehr anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_copy = () => `Ideal zum Einstieg und zum Testen der Klaviyo-Kundenplattform.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_name = () => `Kostenlos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_subtext_bottom = () => `Nicht verfügbar bei mehr als 250 aktiven Profilen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_subtext_top = () => `Beginne mit dem Versand von E-Mails und verfolge, wie du dein Marketing durch die Integration deiner Daten noch besser personalisieren kannst.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_getStarted_text = () => `Jetzt starten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_marketing_analytics_headline = () => `Marketing Analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_marketing_analytics_price_subText = () => `* Basierend auf der oben ausgewählten Anzahl aktiver Profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_marketing_analytics_pricingDescription = () => `Der Preis richtet sich nach der Anzahl aktiver Profile.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_marketing_analytics_subText = () => `Der Preis richtet sich nach der Anzahl aktiver Profile.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_paidCardContent_above250kContacts = () => `Wenn du mehr als 250.000 aktive Profile hast, wende dich bitte an unser Vertriebsteam, um das für dich passende Abonnement zu finden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_paidCardContent_below250Contacts = () => `Mit mehr aktiven Profilen schaltest du Funktionen von Klaviyo AI, mehr Support sowie den Versand von mehr E-Mails frei.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_advanced_data_platform_subText = () => `Wie viele Profile hast du insgesamt?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_advanced_data_platform_subTextInfoHeader = () => `Gesamtzahl der Profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_platform_headline = () => `Leistungsstärkere Tools für dein Marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_reviews_headline = () => `Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_reviews_pricingDescription = () => `Der Preis richtet sich nach der Anzahl monatlicher Bestellungen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_reviews_slider_subText = () => `Wie viele monatliche Bestellungen hast du?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_reviews_subText = () => `Der Preis richtet sich nach der Anzahl monatlicher Bestellungen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plusSign = () => `+`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntrySms = () => `SMS = 4 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_regionName = () => `Australien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntryMms = () => `MMS = 5 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntrySms = () => `SMS = 3 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_regionName = () => `Kanada`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntrySms = () => `SMS = 7 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_regionName = () => `Frankreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntrySms = () => `SMS = 12 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_regionName = () => `Deutschland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntrySms = () => `SMS = 9 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_regionName = () => `Irland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntrySms = () => `SMS = 7 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_regionName = () => `Italien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntrySms = () => `SMS = 10 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_regionName = () => `Neuseeland`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntrySms = () => `SMS = 12 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_regionName = () => `Niederlande`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntrySms = () => `SMS = 3 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_regionName = () => `Portugal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntryMms = () => `MMS = N/A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntrySms = () => `SMS = 5 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_regionName = () => `Vereinigtes Königreich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntryMms = () => `MMS = 3 Credits`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntrySms = () => `SMS = 1 Credit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_regionName = () => `USA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_signUp = () => `Registrieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_startingAt = () => `Ab`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_supportToScale = () => `Support für das Wachstum deines Unternehmens`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_button = () => `Fallstudien erkunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionCredentials_1 = () => `Mitbegründerin und CEO, Fishwife`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionCredentials_2 = () => `Director of Lifecycle Marketing, Made In`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionCredentials_3 = () => `Senior Director of Retention, AS Beauty Group`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionName_1 = () => `Becca Millstein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionName_2 = () => `Don Smolik`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_attributionName_3 = () => `Katherine Cabe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_headline_1 = () => `Gesteigerter ROI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_headline_2 = () => `Größerer durchschnittlicher Bestellwert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_headline_3 = () => `Mehr Umsatz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_href_1 = () => `/customers/case-studies/fishwife`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_href_2 = () => `/customers/case-studies/made-in-cookware`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_href_3 = () => `/customers/case-studies/laura-geller-sms-revenue`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_quote_1 = () => `Bei Klaviyo gefällt mir am besten, dass es für Anfänger*innen und Expert*innen gleichermaßen geeignet ist.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_quote_2 = () => `Dadurch verstehen wir unsere Daten besser und bieten ein besseres Kundenerlebnis.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_card_quote_3 = () => `Es ist ein großer Vorteil, dass wir jetzt einheitliche, zentrale Kundenprofile haben, die alles festhalten, was wir über unsere Kund*innen wissen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_href = () => `/customers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_quote_end = () => `“`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_scroll_social_proof_quote_start = () => `„`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_case_study = () => `Fallstudien durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_compare_page = () => `Vergleiche durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_marketing_resource = () => `Marketing-Ressourcen durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_newsroom_article = () => `Newsroom durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_page = () => `Seiten durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_partner_page = () => `Partner durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_podcast_page = () => `Podcasts durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_post = () => `Blogbeiträge durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_product_update = () => `Produkt-Updates durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_solutions_page = () => `Lösungen durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_searchBar_placeholder_success_page = () => `Erfolgsgeschichten durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_bottom_button = () => `Demo ansehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_bottom_href = () => `/platform-demo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_bottom_subhead = () => `Persönlichere, langfristige Kundenbeziehungen – in großem Maßstab`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_benchmarks = () => `Benchmarks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_customer_hub = () => `Customer Hub`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_email_marketing = () => `E-Mail-Marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_integrations = () => `Integrationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_mobile_push = () => `Mobile Push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_profiles = () => `Profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_reporting = () => `Reporting`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_reviews = () => `Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_segments = () => `Segmente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_pill_sms_marketing = () => `SMS-Marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_button_1 = () => `Klaviyo Marketing erkunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_button_2 = () => `Klaviyo Analytics erkunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_button_3 = () => `Klaviyo Service erkunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_button_4 = () => `Klaviyo Data Platform erkunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_a = () => `E-Mail-Marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_b = () => `SMS-Marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_c = () => `Mobile Push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_d = () => `Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_e = () => `Web-Formulare`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_f = () => `Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_button_g = () => `Kampagnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_a = () => `/products/email-marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_b = () => `/products/sms-marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_c = () => `/products/mobile-push`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_d = () => `/products/product-reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_e = () => `/features/web-forms`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_f = () => `/features/flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_1_href_g = () => `/features/campaigns`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_button_a = () => `Benchmarks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_button_b = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_button_c = () => `Marketing Analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_href_a = () => `/features/benchmarks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_href_b = () => `/products/ai`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_2_href_c = () => `/products/marketing-analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_3_button_a = () => `Customer Hub`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_3_href_a = () => `/products/customer-experience-hub`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_button_a = () => `Integrationen und APIs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_button_b = () => `Profile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_button_c = () => `Segmente`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_button_d = () => `Advanced KDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_href_a = () => `/platform-integrations`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_href_b = () => `/features/customer-profiles`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_href_c = () => `/features/segmentation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_arr_4_href_d = () => `/products/advanced-cdp`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_title_1 = () => `Erkunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_title_2 = () => `Erkunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_title_3 = () => `Erkunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_explore_title_4 = () => `Erkunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_headline_1 = () => `Marketing`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_headline_2 = () => `Auswertungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_headline_3 = () => `Service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_headline_4 = () => `Datenplattform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_href_1 = () => `/solutions/marketing-automation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_href_2 = () => `/solutions/analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_href_3 = () => `/solutions/customer-service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_href_4 = () => `/solutions/customer-data-platform`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_27Percent = () => `27,2 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_43Percent = () => `43,2 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_a = () => `A`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_b = () => `B`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_clickRate = () => `Klickrate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_consentedToReceiveSMS = () => `Dem Empfang von SMS zugestimmt?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_createWithAI = () => `Mit KI erstellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_describeFlow = () => `Flow beschreiben`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_dontLeaveItBehind = () => `Lass es dir nicht entgehen. Klicke hier, um zu kaufen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_flowTrigger = () => `Flow-Auslöser`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_generateDraft = () => `Entwurf generieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_hasViewedProduct = () => `Produkt aufgerufen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_klaviyoAI = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_no = () => `Nein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_smsABTest = () => `A/B-Test für SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_viewAbandonedProduct = () => `Warenkorbabbruch-Produkt anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_weLoveThatYouLoveThisDontLeaveItBehindClickToShop = () => `Nachricht 1`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_whenSomeoneViewsAProductAndDoesNotBuySendAnSMS = () => `Eingabenachricht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_1_yes = () => `Ja`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_attributedRevenue = () => `Zugeschriebener Umsatz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_attributedRevenueNumber = () => `Zugeschriebener Umsatz – Zahl`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_champions = () => `Champions`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_championsFlow = () => `Champions-Flow`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_clickRate = () => `Klickrate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_conversionOverview = () => `Conversion-Übersicht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_conversionRate = () => `Conversion-Rate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_eightPercent = () => `8 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_excellent = () => `Ausgezeichnet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_exclusiveOffer = () => `Exklusives Angebot`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_fivePointTwoZeroPercent = () => `5,20 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_flowTrigger = () => `Flow-Auslöser`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_fortyThreeThousandSixHundredNineteen = () => `43.619`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_fourHundredFiftyTwo = () => `452`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_membersAdded = () => `Mitglieder hinzugefügt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_membersDropped = () => `Mitglieder entfernt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_monthOne = () => `Monat 1`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_monthTwo = () => `Monat 2`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_no = () => `Nein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_oneThousandFiveHundredThirteen = () => `1.513`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_revenue = () => `Umsatz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_revenueNumber = () => `Umsatz – Zahl`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_rfmGroupIsChampion = () => `RFM-Gruppe ist Champion`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_segmentGrowthReport = () => `Bericht zum Segmentwachstum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_sevenPointFiveZeroPercent = () => `7,50 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_threePercent = () => `3 %`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_totalMembers = () => `Mitglieder gesamt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_2_yes = () => `Ja`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_accessories = () => `Accessoires`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_activity = () => `Aktivität`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_addToBag = () => `In den Warenkorb`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_addToCart = () => `Zum Warenkorb hinzufügen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_arrivingToday = () => `Kommt heute an`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_chat = () => `Chat`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_clothing = () => `Bekleidung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_color = () => `Farbe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_coral = () => `Coral`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_featherweightRunningShoes = () => `Federleichte Laufschuhe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_findAStore = () => `Filiale finden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_forYou = () => `Für dich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_help = () => `Hilfe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_horizonRibbedTrainingSet = () => `Geripptes Training-Set Horizon`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_l = () => `L`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_maroon = () => `Maroon`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_membersFreeShippingOnOrdersFiftyPlus = () => `Mitglieder: Kostenloser Versand bei Bestellwert über 50 €`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_miaWilliams = () => `Mia Williams`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_miaWilliamsAtAbcDotCom = () => `mia.williams@abc.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedTheWrongSizeShoes = () => `Meine Bestellung ist gerade angekommen und es sieht aus, als hätte ich die falsche Schuhgröße erhalten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_new = () => `Neu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_orders = () => `Bestellungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_phoneNumber = () => `+49 1 23 45 67 89`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_pleaseHoldForAMomentWhileWeConnectYouWithAnAgent = () => `Bitte warte einen Moment, während wir dich mit einem Service-Mitarbeiter verbinden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_profile = () => `Profil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_recentlyViewed = () => `Zuletzt angesehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_saySomething = () => `Sag etwas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_seanH = () => `Sean H.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_selectSize = () => `Größe auswählen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_shoes = () => `Schuhe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_sky = () => `Sky`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_sorryAboutThatMiaWellGetTheCorrectColorShippedOutToday = () => `Das tut mir leid, Mia. Die richtige Farbe geht noch heute raus.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_thirtyFivePointNinetyNine = () => `35,99 €`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_twoHundredTen = () => `210 €`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_unifiedInbox = () => `Unified Inbox`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_welcomeMia = () => `Willkommen, Mia`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_xl = () => `XL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_xs = () => `XS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_xxl = () => `XXL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_3_yesThatsMyOrderThanksForYourHelp = () => `Ja, das ist meine Bestellung. Danke für deine Hilfe!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_Enjoy = () => `Erhalte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_customerActivity = () => `Kundenaktivität`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_discountCode = () => `Rabattcode`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_email = () => `dana.kim@abc.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_flowTrigger = () => `Flow-Auslöser`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_inbox = () => `Posteingang`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_leftFiveStarReview = () => `5-Sterne-Bewertung hinterlassen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_name = () => `Dana Kim`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_no = () => `Nein`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_openedEmailDiscount = () => `E-Mail-Rabatt geöffnet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_orderDelivered = () => `Bestellung geliefert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_orderShipped = () => `Bestellung versandt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_placedOrderForTwoHundredSix = () => `Bestellung für 206 € aufgegeben`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_shopNow = () => `Jetzt kaufen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_tenPercentOff = () => `10 % Rabatt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_thanksForYourFeedbackEnjoy = () => `Danke für dein Feedback`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_rive_4_yes = () => `Ja`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_subhead_1 = () => `Sende Nachrichten, die Wirkung zeigen, auf allen richtigen Kanälen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_subhead_2 = () => `Erhalte klare Einsichten darüber, was gut funktioniert und was als Nächstes ansteht.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_subhead_3 = () => `Personalisiere den Kundenservice für zufriedenere Kund*innen und mehr Verkaufschancen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_solutionsScrollAccordion_row_subhead_4 = () => `Vereinheitliche alle deine Daten, um das Gesamtbild aller Kund*innen zu erhalten und ihre Wünsche zu antizipieren.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_tileList_viewAll = () => `Alle anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_video_playVideo = () => `Video abspielen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_clearAll = () => `Alle entfernen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_collapseAll = () => `Alles minimieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_filterTitle = () => `Alle Updates`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_placeholder = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_accounts_billing = () => `Konto und Abrechnung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_advanced_kdp = () => `Advanced KDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_analytics = () => `Auswertungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_audience = () => `Zielgruppe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_benefits = () => `Vorteile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_campaigns = () => `Kampagnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_coming_soon = () => `Demnächst verfügbar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_deliver_compliance = () => `Zustellbarkeit und Compliance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_email = () => `Email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_flows = () => `Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_general_availability = () => `Allgemeine Verfügbarkeit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_gradual_release = () => `Schrittweise Veröffentlichung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_integrations = () => `Integrationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_limited_availability = () => `Begrenzte Verfügbarkeit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_marketing_analytics = () => `Klaviyo Marketing Analytics`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_push_notifications = () => `Push-Benachrichtigungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_release_type = () => `Art der Veröffentlichung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_reviews = () => `Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sign_up_forms = () => `Anmeldeformulare`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_topic = () => `Thema`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_watchQuarterlyRecap = () => `Vierteljahresrückblick ansehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_home = () => `Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_searchJobs = () => `Stellen suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_applyFilters = () => `Filter anwenden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_clearFilters = () => `Filter entfernen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_country = () => `Land`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywords = () => `Stichwörter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywordsPlaceholder = () => `Stellen suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_legend = () => `Stellen filtern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_location = () => `Standort`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResults = () => `Es wurde leider keine Stelle gefunden, die deinen Kriterien entspricht.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResultsReset = () => `Bitte versuche es mit anderen Suchkriterien oder klicke, um <a href="#" onclick="window.location.href='/careers/search-jobs'">alle unsere offenen Stellen anzuzeigen</a>.`


/**
 * @param {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_searchResults = (params) => `Angezeigt werden <strong>${params.start}</strong>–<strong>${params.end}</strong> von <strong>${params.total}</strong> passenden Stellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_team = () => `Team`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_headline = () => `Stellen suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_pageTitle = () => `Stellen suchen | Karriere bei Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_recentJobs = () => `Zuletzt angesehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_savedJobs = () => `Gespeicherte Stellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_bodyCopy = () => `Nicht das, wonach du gesucht hast? Gehe zur <a href="/email-marketing">Email-Seite</a>, zur <a href="/sms-marketing">SMS-Seite</a> oder zur <a href="/">Startseite</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_button = () => `Zur Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_eyebrow = () => `Seite nicht gefunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_itsPronounced = () => `Es wird so ausgesprochen:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardHours = () => `Stunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardMinutes = () => `Minuten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularHour = () => `Stunde`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularMinute = () => `Minute`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_community_answered = () => `Frage beantwortet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_academy = () => `Academy`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_allResources = () => `Alle Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_clearAll = () => `Alle entfernen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_collapseAll = () => `Alles minimieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_community = () => `Community`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_developers = () => `Entwickler*innen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_helpCenter = () => `Help Center`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_klaviyoHome = () => `Marketing-Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_resource = () => `Ressourcen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_headline = () => `Alle Ressourcen durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsSubTitle = () => `Überprüfe die Schreibweise oder probiere es mit einer anderen Suche.`


/**
 * @param {{ query: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsTitle = (params) => `Für „${params.query}“ konnten wir keine Ergebnisse finden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_placeholder = () => `Nach Thema oder Stichwort suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_duration = () => `Dauer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_language = () => `Sprache`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_location = () => `Ort`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_type = () => `Typ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_english = () => `Englisch`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_french = () => `Französisch`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_spanish = () => `Spanisch`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_apac = () => `Asien/Australien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_emea = () => `Europa/Afrika`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_nam = () => `Nordamerika`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_type_liveTraining = () => `Live-Training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_category = () => `Kategorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType = () => `Art des Beitrags`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_bfcm_page = () => `Black Friday und Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_case_study = () => `Fallstudie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_compare_page = () => `Vergleiche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_demos_page = () => `Demos`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_industry_page = () => `Branchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_marketing_resource = () => `Marketing-Ressource`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_newsroom_article = () => `Newsroom`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_page = () => `Seiten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_partner_page = () => `Partner`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_podcast_page = () => `Podcast`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_post = () => `Blog`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_product_update = () => `Produkt-Update`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_products_page = () => `Produkte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_quarterly_page = () => `Vierteljährliche Veröffentlichung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_solutions_page = () => `Lösungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_success_page = () => `Erfolg`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_tools_page = () => `Tools`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_accounts_billing = () => `Konto und Abrechnung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_analytics = () => `Auswertungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_audience = () => `Zielgruppe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_campaigns = () => `Kampagnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_cdp = () => `CDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_deliver_compliance = () => `Zustellbarkeit und Compliance`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_email = () => `Email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_flows = () => `Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_integrations = () => `Integrationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_push_notifications = () => `Push-Benachrichtigungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_reviews = () => `Reviews`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sign_up_forms = () => `Anmeldeformulare`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelTop = () => `Top-Suchergebnisse`


/**
 * @param {{ y: NonNullable<unknown>, x: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelYofX = (params) => `Angezeigt werden ${params.y} von ${params.x}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearchesTitle = () => `Vorgeschlagene Suchanfragen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search1 = () => `Erste Schritte mit Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search2 = () => `Erste Schritte mit SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search3 = () => `Erste Schritte mit der CDP von Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search4 = () => `Erste Schritte mit Formularen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search5 = () => `Black Friday Cyber Monday`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search6 = () => `Erstelle einen Content-Kalender in Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_toggleLabel = () => `Anzeigen`


/**
 * @param {{ index: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewAllResults = (params) => `Alle ${params.index} Ergebnisse anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewMoreResults = () => `Mehr anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_header = () => `Kategorie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_title = () => `Klaviyo-Sitemap`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_brandText = () => `Erzähle uns von deiner Marke`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_channelsUsed = () => `Welche Kanäle nutzt du?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_fieldsRequired = () => `* Alle Felder müssen ausgefüllt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputActiveProfiles = () => `Anzahl aktiver Profile*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputAverageOrderValue = () => `Durchschnittlicher Bestellwert*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputCampaignsPerMonth = () => `Versendete Kampagnen pro Monat (E-Mail und SMS)*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterActiveProfiles = () => `Gib die Anzahl aktiver Profile ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterAverageOrderValue = () => `Gib einen Betrag in US-Dollar ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterCampaignsPerMonth = () => `Gib die Anzahl der Kampagnen ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterFlowsPerMonth = () => `Gib die Anzahl der Empfänger*innen ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterMonthlyWebVisitors = () => `Gib die Anzahl der Besucher*innen ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterOrdersPerMonth = () => `Gib die Anzahl der Bestellungen ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputEnterSmsPerMonth = () => `Gib die Anzahl der Nachrichten ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputFlowsPerMonth = () => `Empfänger*innen, die jeden Monat einen automatisierten Flow erhalten*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputMonthlyWebVisitors = () => `Neue Web-Besucher*innen/Monat*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputOrdersPerMonth = () => `Durchschnittliche Anzahl der Bestellungen pro Kund*in pro Monat*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputPrefix = () => `$`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_inputSmsPerMonth = () => `SMS-Nachrichten pro Monat*`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_roiButton = () => `ROI schätzen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_toggleEmail = () => `Email`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_form_toggleEmailAndSms = () => `Email und SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_automatedFlows = () => `Automatisierte Flows`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_campaigns = () => `Kampagnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_freeTier = () => `Dein Business Case ist einzigartig und wir können keinen ROI für dich berechnen. Da dein Unternehmen weniger als 250 Profile hat, kannst du Klaviyo kostenlos nutzen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_getStartedButton = () => `Jetzt starten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_headlineText = () => `* Dein geschätzter ROI mit Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_invalidRoi = () => `Dein Business Case ist einzigartig. Wir würden dir gerne ausführlicher erläutern, wie Klaviyo deinem Unternehmen einen Mehrwert bieten kann.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_newSubscribers = () => `Neue Abonnent*innen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_revenuePerYear = () => `pro Jahr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_signupText = () => `Registriere dich, um zu beginnen, oder unterhalte dich mit dem Vertrieb über deine ROI-Ergebnisse.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_subHeadlineText = () => `Erfahre, woher dein Umsatz stammt:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const roiCalculator_results_talkToSales = () => `Mit Vertrieb sprechen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_openInANewTab = () => `in einer neuen Registerkarte öffnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_postsByThisAuthor = () => `Beiträge dieser Person`


/**
 * @param {{ category_name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_articles = (params) => `Artikel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_featured = () => `Ausgewählt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_customer = () => `Kunde`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_industry = () => `Branche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_platform = () => `Plattform`


export { pages_b2ccrm_hero_video_id } from "./en-US.js"

export { pages_b2ccrm_introduction_subtext } from "./en-US.js"

export { pages_b2ccrm_marketing_p1 } from "./en-US.js"

export { pages_b2ccrm_marketing_p2 } from "./en-US.js"

export { pages_b2ccrm_marketing_p3 } from "./en-US.js"

export { pages_b2ccrm_service_p1 } from "./en-US.js"

export { pages_b2ccrm_service_rive_message_2 } from "./en-US.js"

export { pages_b2ccrm_service_rive_phone_number } from "./en-US.js"

export { pages_b2ccrm_analytics_rive_revenue_number_sign } from "./en-US.js"

export { pages_b2ccrm_platform_rive_placed_order } from "./en-US.js"

export { pages_b2ccrm_service_rive_dash_item_cost } from "./en-US.js"

export { pages_b2ccrm_service_rive_item_price } from "./en-US.js"

export { pages_b2ccrm_service_rive_shipping } from "./en-US.js"

export { roiCalculator_results_getStartedButton_href } from "./en-US.js"

export { roiCalculator_results_talkToSales_href } from "./en-US.js"

export { AppMarketplace_Browse_Heading } from "./en-US.js"

export { AppMarketplace_Discovery_App_BuiltBy } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_ActionRequired } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_GenericPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_Installed } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_UserPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllApps } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllAppsAriaLabel } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL1 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2Highlight } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericMobileHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_LogInAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_SignUpAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserGreeting } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserHeading } from "./en-US.js"

export { AppMarketplace_Header_CategoriesButton_Label } from "./en-US.js"

export { AppMarketplace_Header_LoginButton_Label } from "./en-US.js"

export { AppMarketplace_Header_Logo_Alt } from "./en-US.js"

export { AppMarketplace_Header_MenuIcon_Alt } from "./en-US.js"

export { AppMarketplace_Header_SearchBar_SearchIcon_Alt } from "./en-US.js"

export { academy_lesson_bottom_nav_catalog_label } from "./en-US.js"

export { academy_lesson_bottom_nav_collection_label } from "./en-US.js"

export { academy_pages_bestPractices_headline } from "./en-US.js"

export { academy_pages_bestPractices_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_headline } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_subhead } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_title } from "./en-US.js"

export { academy_pages_cred_faq_headline } from "./en-US.js"

export { academy_pages_cred_faq_row0_content } from "./en-US.js"

export { academy_pages_cred_faq_row0_title } from "./en-US.js"

export { academy_pages_cred_faq_row1_content } from "./en-US.js"

export { academy_pages_cred_faq_row1_title } from "./en-US.js"

export { academy_pages_cred_faq_row2_content } from "./en-US.js"

export { academy_pages_cred_faq_row2_title } from "./en-US.js"

export { academy_pages_cred_faq_row3_content } from "./en-US.js"

export { academy_pages_cred_faq_row3_title } from "./en-US.js"

export { academy_pages_cred_faq_row4_content } from "./en-US.js"

export { academy_pages_cred_faq_row4_title } from "./en-US.js"

export { academy_pages_cred_faq_row5_content } from "./en-US.js"

export { academy_pages_cred_faq_row5_title } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_4 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_5 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_6 } from "./en-US.js"

export { academy_pages_cred_faq_row6_title } from "./en-US.js"

export { academy_pages_cred_faq_subhead } from "./en-US.js"

export { academy_pages_cred_landing_34 } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_collapse } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_expand } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_subtitle } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_header } from "./en-US.js"

export { academy_pages_cred_landing_hero_headline } from "./en-US.js"

export { academy_pages_cred_landing_hero_subhead } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_headline } from "./en-US.js"

export { academy_partner_tag } from "./en-US.js"

export { academy_search_href } from "./en-US.js"

export { app_marketplace_details_built_by } from "./en-US.js"

export { app_marketplace_details_carousel_close } from "./en-US.js"

export { app_marketplace_details_carousel_image_alt } from "./en-US.js"

export { app_marketplace_details_carousel_next_image } from "./en-US.js"

export { app_marketplace_details_carousel_previous_image } from "./en-US.js"

export { app_marketplace_details_case_study } from "./en-US.js"

export { app_marketplace_details_category } from "./en-US.js"

export { app_marketplace_details_cover_image } from "./en-US.js"

export { app_marketplace_details_developer } from "./en-US.js"

export { app_marketplace_details_features } from "./en-US.js"

export { app_marketplace_details_guide } from "./en-US.js"

export { app_marketplace_details_install } from "./en-US.js"

export { app_marketplace_details_install_installs } from "./en-US.js"

export { app_marketplace_details_languages } from "./en-US.js"

export { app_marketplace_details_marketing_video } from "./en-US.js"

export { app_marketplace_details_overview } from "./en-US.js"

export { app_marketplace_details_pricing } from "./en-US.js"

export { app_marketplace_details_pricing_free } from "./en-US.js"

export { app_marketplace_details_pricing_learn_more } from "./en-US.js"

export { app_marketplace_details_similar_apps } from "./en-US.js"

export { app_marketplace_details_support } from "./en-US.js"

export { app_marketplace_details_support_help } from "./en-US.js"

export { app_marketplace_details_support_privacy } from "./en-US.js"

export { app_marketplace_details_support_website } from "./en-US.js"

export { app_marketplace_details_user_guide } from "./en-US.js"

export { app_marketplace_gallery_thumbnail } from "./en-US.js"

export { app_marketplace_gallery_thumbnail_alt } from "./en-US.js"

export { app_marketplace_install_alert_learn_more } from "./en-US.js"

export { app_marketplace_install_button } from "./en-US.js"

export { app_marketplace_install_status_invalid_permissions } from "./en-US.js"

export { app_marketplace_install_status_unhealthy } from "./en-US.js"

export { app_marketplace_install_status_uninstallable } from "./en-US.js"

export { app_marketplace_installed_button } from "./en-US.js"

export { app_marketplace_manage_button } from "./en-US.js"

export { app_marketplace_notFound_button_text } from "./en-US.js"

export { app_marketplace_preview_banner } from "./en-US.js"

export { developer_portal_get_started_card_one_description } from "./en-US.js"

export { developer_portal_get_started_card_one_title } from "./en-US.js"

export { developer_portal_get_started_card_three_description } from "./en-US.js"

export { developer_portal_get_started_card_three_title } from "./en-US.js"

export { developer_portal_get_started_card_two_description } from "./en-US.js"

export { developer_portal_get_started_card_two_title } from "./en-US.js"

export { developer_portal_get_started_header } from "./en-US.js"

export { developer_portal_need_more_help_card_one_description } from "./en-US.js"

export { developer_portal_need_more_help_card_one_title } from "./en-US.js"

export { developer_portal_need_more_help_card_two_description } from "./en-US.js"

export { developer_portal_need_more_help_card_two_title } from "./en-US.js"

export { developer_portal_need_more_help_header } from "./en-US.js"

export { developer_portal_use_cases_cta } from "./en-US.js"

export { developer_portal_use_cases_header } from "./en-US.js"

export { developer_portal_use_cases_tab_one_author } from "./en-US.js"

export { developer_portal_use_cases_tab_one_description } from "./en-US.js"

export { developer_portal_use_cases_tab_one_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_one_title } from "./en-US.js"

export { developer_portal_use_cases_tab_three_author } from "./en-US.js"

export { developer_portal_use_cases_tab_three_description } from "./en-US.js"

export { developer_portal_use_cases_tab_three_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_three_title } from "./en-US.js"

export { developer_portal_use_cases_tab_two_author } from "./en-US.js"

export { developer_portal_use_cases_tab_two_description } from "./en-US.js"

export { developer_portal_use_cases_tab_two_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_two_title } from "./en-US.js"

export { molecules_blogCard_related_content } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_profile_href } from "./en-US.js"

export { organisms_forms_fields_company_website_placeholder } from "./en-US.js"

export { organisms_forms_fields_firstname_placeholder } from "./en-US.js"

export { organisms_forms_fields_form_opt_in_label } from "./en-US.js"

export { organisms_forms_fields_lastname_placeholder } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_errors_required } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_placeholder } from "./en-US.js"

export { organisms_forms_fields_website_errors_required } from "./en-US.js"

export { organisms_forms_fields_website_placeholder } from "./en-US.js"

export { organisms_moreCards_card1_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card2_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card3_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card3_richText_template } from "./en-US.js"

export { pages_b2ccrm_analytics_cta } from "./en-US.js"

export { pages_b2ccrm_analytics_eyebrow } from "./en-US.js"

export { pages_b2ccrm_analytics_headline } from "./en-US.js"

export { pages_b2ccrm_analytics_logo } from "./en-US.js"

export { pages_b2ccrm_analytics_p1 } from "./en-US.js"

export { pages_b2ccrm_analytics_p2 } from "./en-US.js"

export { pages_b2ccrm_analytics_p3 } from "./en-US.js"

export { pages_b2ccrm_analytics_quote } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_title } from "./en-US.js"

export { pages_b2ccrm_description } from "./en-US.js"

export { pages_b2ccrm_hero_content_cta } from "./en-US.js"

export { pages_b2ccrm_hero_content_finally } from "./en-US.js"

export { pages_b2ccrm_hero_content_title } from "./en-US.js"

export { pages_b2ccrm_hero_rip_headline } from "./en-US.js"

export { pages_b2ccrm_hero_rip_instructions } from "./en-US.js"

export { pages_b2ccrm_introduction_eyebrow } from "./en-US.js"

export { pages_b2ccrm_introduction_headline } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_tag } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4_copy } from "./en-US.js"

export { pages_b2ccrm_marketing_cta } from "./en-US.js"

export { pages_b2ccrm_marketing_eyebrow } from "./en-US.js"

export { pages_b2ccrm_marketing_headline } from "./en-US.js"

export { pages_b2ccrm_marketing_logo } from "./en-US.js"

export { pages_b2ccrm_marketing_quote } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_title } from "./en-US.js"

export { pages_b2ccrm_nav_analytics } from "./en-US.js"

export { pages_b2ccrm_nav_marketing } from "./en-US.js"

export { pages_b2ccrm_nav_platform } from "./en-US.js"

export { pages_b2ccrm_nav_quiz } from "./en-US.js"

export { pages_b2ccrm_nav_service } from "./en-US.js"

export { pages_b2ccrm_nav_the_b2c_crm } from "./en-US.js"

export { pages_b2ccrm_nav_watch_demo } from "./en-US.js"

export { pages_b2ccrm_platform_cta } from "./en-US.js"

export { pages_b2ccrm_platform_eyebrow } from "./en-US.js"

export { pages_b2ccrm_platform_headline } from "./en-US.js"

export { pages_b2ccrm_platform_logo } from "./en-US.js"

export { pages_b2ccrm_platform_p1 } from "./en-US.js"

export { pages_b2ccrm_platform_p2 } from "./en-US.js"

export { pages_b2ccrm_platform_p3 } from "./en-US.js"

export { pages_b2ccrm_platform_stat } from "./en-US.js"

export { pages_b2ccrm_platform_stat_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_cta } from "./en-US.js"

export { pages_b2ccrm_quiz_eyebrow } from "./en-US.js"

export { pages_b2ccrm_quiz_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_subtext } from "./en-US.js"

export { pages_b2ccrm_service_cta } from "./en-US.js"

export { pages_b2ccrm_service_eyebrow } from "./en-US.js"

export { pages_b2ccrm_service_headline } from "./en-US.js"

export { pages_b2ccrm_service_logo } from "./en-US.js"

export { pages_b2ccrm_service_p2 } from "./en-US.js"

export { pages_b2ccrm_service_p3 } from "./en-US.js"

export { pages_b2ccrm_service_quote } from "./en-US.js"

export { pages_b2ccrm_service_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_service_quote_title } from "./en-US.js"

export { pages_b2ccrm_title } from "./en-US.js"

export { academy_courseStatus_registed } from "./en-US.js"

export { helpCenter_templates_search_results } from "./en-US.js"

export { organisms_forms_legal_agreeTermsLinkText } from "./en-US.js"

export { organisms_forms_legal_agreeToPartnerCodeOfConduct } from "./en-US.js"

export { organisms_forms_legal_agreeToTermsOfService } from "./en-US.js"

export { organisms_forms_legal_codeOfConduct_href } from "./en-US.js"

export { organisms_forms_legal_marketingCommunicationsConsent } from "./en-US.js"

export { organisms_pricing_plans_advance_data_platform_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_buttons_getDemo } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_headline } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_richTextBody } from "./en-US.js"

export { organisms_pricing_calculator_locales_BR } from "./en-US.js"